import View from '@play-co/timestep-core/lib/ui/View';
import { ImageView } from '@play-co/timestep-core/ui';
import { getRandomItemFromArray } from 'src/replicant/utils/random';

export type CreativeAsset = {
  id: string;
  image: string;
  gifUrl?: string;
  vidUrl?: string;
  textId?: string;
};

export const getLineUpdateCreativeView = () => getCreativeView(720, 477);
export const getLineShareCreativeView = () => getCreativeView(720, 1116);

export function getCreativeView(width: number, height: number): View {
  return new View({
    // x: uiConfig.width / 2,
    // y: 205,
    width,
    height,
    clip: true,
    centerOnOrigin: true,
  });
}

export function renderCreativeView(id: string, view: View): CreativeAsset {
  return {
    id: id,
    image: view.style.renderToDataURL('image/jpeg'),
  };
}

export function createBackground(opts: {
  superview: View;
  zIndex?: number;
  image: string;
}) {
  const { superview, zIndex, image } = opts;
  return new ImageView({
    superview,
    zIndex: zIndex || 0,
    image,
    width: superview.style.width,
    height: superview.style.height,
  });
}

type IntRange1to12 = 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12;

// prettier-ignore
type IntRange1to31 = 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12 | 13 | 14 | 15 | 16 | 17 | 18 | 19 | 20 | 21 | 22 | 23 | 24 | 25 | 26 | 27 | 28 | 29 | 30 | 31;

export async function getRandomCreativeAsset(
  prefixId: `${2022 | 2023 | 2024 | 2025 | 2026}-${0 | ''}${IntRange1to12}-${0 | ''}${IntRange1to31}`,
  best: Array<() => Promise<CreativeAsset>>,
  worst?: Array<() => Promise<CreativeAsset>>,
): Promise<CreativeAsset> {
  // 70% chance to pick the best performers
  // If we have no worst performers, use the best
  const choices = Math.random() >= 0.3 || !worst ? best : worst;
  const creative = await getRandomItemFromArray(choices, Math.random)();

  // Add the prefix back to the id
  creative.id = prefixId + '-' + creative.id;
  return creative;
}

export type CreativeAssetsType = 'universal';

export function getCreativeAssetsType(): CreativeAssetsType {
  let result: CreativeAssetsType = 'universal';

  return result;
}
